import $http from "@/plugins/axios";
import store from "@/store/store";
import ActionTypes from "@/store/ActionTypes";

const BotService = {
    getAllBot() {
        return $http.get('/live-support/get-user-bots/')
    },
    getManageBot() {
        return $http.get('/live-support/get_manage_bot_list/')
    },
    getBotStatus(senderId, botCode) {
        let _senderId = encodeURIComponent(senderId);
        return $http.get(
            `/live-support/bot-status/${botCode}/?channel=${store.getters.channel}&sender_id=${_senderId}`
        )
    },
    setBotStatus(senderId, botCode, status) {
        return $http.put(
            `/live-support/bot-status/${botCode}/`,
            {
                sender_id: senderId,
                channel: store.getters.channel,
                status: status
            }
        )
    },
    markSupportDone(senderId, botCode, is_create_new_request_human_support, is_disable_bot,
                    request_comment, request_support_categories, need_re_support, description, notes, topic, customer_attributes, is_create_rating) {
        // postMessage to parent embedded iframe
        const madData = {
            sender_id: senderId,
            channel: store.getters.channel,
            is_create_new_request_human_support,
            is_disable_bot,
            request_comment,
            request_support_categories,
            description,
            notes,
            topic,
            customer_attributes,
            need_re_support,
            is_create_rating
        }
        return $http.put(
            `/live-support/mark-support-done-v2/${botCode}/`,
            madData
        )
    },
    bulkMAD(botCode, ls_type, from_time, to_time,  channel) {
        return $http.post(
            `/live-support/bulk-mad/${botCode}/`,
            {
                ls_type, from_time, to_time,  channel
            }
        )
    },
    getCustomerInfo(botCode, senderId) {
        return $http.get(`/live-support/customer/${botCode}/${senderId}`)
    },
    getListChannels(botCode) {
        return $http.get(`/live-support/list-channels-by-bot/${botCode}`)
    },
    saveSessionInfo(botCode, senderId, userId, sessionId, description, notes, topic, customer_attributes, created_time) {
        return $http.post(`/live-support/session-info/${botCode}/${senderId}/`,
            {
                sender_id: senderId,
                session_id: sessionId,
                description: description,
                notes: notes,
                topic: topic,
                customer_attributes: customer_attributes,
                created: created_time
            });
    },
    getSessionInfo(botCode, senderId) {
        return $http.get(`/live-support/session-info/${botCode}/${senderId}?page_size=1000`);
    },
    updateSessionInfo(botCode, senderId, id, description, notes, topic) {
        return $http.patch(`/live-support/session-info/${botCode}/${senderId}/`, {
            description: description,
            notes: notes,
            topic: topic,
            _id: id
        })
    },
    getCustomInfo(botCode) {
        return $http.get(`/live-support/custom-info/${botCode}/`)
    },
    saveCustomInfo(botCode, data) {
        return $http.post(`/live-support/custom-info/${botCode}/`, data)
    },
    getSessionReportConfig(botCode) {
        return $http.get(`/live-support/session-report-config/${botCode}/`)
    },
    saveSessionReportConfig(botCode, config_data) {
        return $http.post(`/live-support/session-report-config/${botCode}/`, {
            config_data: config_data
        })
    },
    getChatLogBySessionID(botCode, senderId, sessionId, nextUrl) {
        let url = `/live-support/get-admin-chatlog/${botCode}/${senderId}?session_id=${sessionId}`;
        if (nextUrl !== '') {
            url = nextUrl + `&session_id=${sessionId}`;
            url = url.replace('/backend/api/v1', '');
        }
        return $http.get(url);
    },
    getChatLog(botCode, senderId) {
        return $http.get(`/live-support/get-admin-chatlog/${botCode}/${senderId}`)
    },
    adminGetChatLogById(botCode, senderId,chatLogId) {
        return $http.get(`/live-support/get-chatlog/${botCode}/${senderId}?chat_log_id=${chatLogId}`)
    },
    // start auto assign config api
    getAutoAssignStatus(botCode) {
        return $http.get(`/live-support/auto-assign-config/${botCode}/get-config/`)
    },
    updateAutoAssignStatusCurrentBot(botCode, status) {
        return $http.post(`/live-support/auto-assign-config/${botCode}/member/update-status/`, {
            status: status
        })
    },
    updateAutoAssignStatusAllBot(status) {
        return $http.post(`/live-support/auto-assign-config/update-status-all-bot/`, {
            status: status
        })
    },
    getAutoAssignStatus_manage(botCode) {
        return $http.get(`/live-support/auto-assign-config/${botCode}/manage/get-all-configs/`).then(
            response => {
                store.commit(ActionTypes.GET_ALL_AUTO_ASSIGN_CONFIG, response.data);
                return response;
            }
        )
    },
    updateAutoAssignConfig_manage(botCode, data) {
        return $http.post(`/live-support/auto-assign-config/${botCode}/manage/update-auto-assign-config/`, data)
    },
    updateAutoAssignSupporterConfig_manage(botCode, user_id, data) {
        return $http.post(`/live-support/auto-assign-config/${botCode}/manage/update-auto-assign-supporter-config/`, {
            user_id: user_id,
            ...data
        })
    },
    updateAutoAssignConfigMultipleSupporter(botCode, usersId, categories) {
        return $http.post(`/live-support/auto-assign-config/${botCode}/manage/update-auto-assign-multiple-supporter-config/`,
            {
                users_id: usersId,
                categories: categories
            })
    },
    updateMaxSupportingConfig(botCode, max_supporting) {
        return $http.post(`/live-support/auto-assign-config/${botCode}/manage/update-max-supporting/`, {
            max_supporting: max_supporting
        })
    },
    // end auto assign config api
    mark_seen(botCode, sender_id) {
        return $http.post(`/live-support/seen/${botCode}/${sender_id}/`, {})
    },
    mark_typing(botCode, sender_id) {
        return $http.post(`/live-support/typing/${botCode}/${sender_id}/`, {})
    },
    mark_typing_off(botCode, sender_id) {
        return $http.post(`/live-support/typing_off/${botCode}/${sender_id}/`, {})
    },
    getCRMCollection(botCode) {
        return $http.get("/live-support/" + botCode + "/get-crm-collection/");
    },
    getBotConfigSuggestHobby(botCode) {
        return $http.get(`/live-support/bot-allow-livesupport-suggest-hobby/${botCode}/`)
    },
    getConversationTypesReport(botCode, filter) {
        return $http.get(`/live-support/report-message-categories/${botCode}`, {params: filter})
    },
    getBotConfig(botCode) {
        return $http.get(`/live-support/bot-config/${botCode}`)
    },
    getTicket(botCode, senderId) {
        return $http.get(`/live-support/ticket/${botCode}/${senderId}`);
    },
    getCountOpeningTicket(botCode, senderId) {
        return $http.get(`/live-support/count-ticket-opening/${botCode}/${senderId}`);
    },
    closeTicket(botCode, tktId) {
        return $http.patch(`/live-support/close-ticket/${botCode}/${tktId}`);
    },
    getTicketsOverview(botCode, channels, from, to) {
        return $http.get(`/live-support/ticket-overview/${botCode}?channels=${channels}&from=${from}&to=${to}`)
    },
    changeTicketStatus(botCode, tktId, status) {
        let data = { status: status };
        return $http.patch(`/live-support/update-ticket-status/${botCode}/${tktId}`, data)
    },
    getBotNotifySetting(botCode) {
        return $http.get(`/live-support/user-notify/config/${botCode}/`)
    },
    updateBotNotifySetting(botCode, config) {
        return $http.post(`/live-support/user-notify/config/${botCode}/`, config)
    },
    getBotSelectedCRMAttributes(botCode){
        return $http.get(`/live-support/selected_crm_attributes/${botCode}/`)
    },
    updateBotSelectedCRMAttributes(botCode, config) {
        return $http.post(`/live-support/selected_crm_attributes/${botCode}/`, config)
    },
    getAgentConfigs(botCode) {
        return $http.get(`/live-support/agent-config/${botCode}/`).then(res=> {
            store.commit(ActionTypes.AGENT_CONFIG, res.data);
        })
    },
    setAgentConfig_ShowLastAgentMessage(botCode, config_value) {
        return $http.put(`/live-support/agent-config/${botCode}/show-last-agent-message/`, {
            config_value: config_value
        })
    },
    setAgentConfig_ShowLastBotMessage(botCode, config_value) {
        return $http.put(`/live-support/agent-config/${botCode}/show-last-bot-message/`, {
            config_value: config_value
        })
    },
    updateAllowEditCRMSetting(botCode, config_value) {
        return $http.put(`/live-support/role-config/${botCode}/allow-supporter-update-sender-crm-attributes/`, {
            config_value: config_value
        })
    },
    updateAllowBlockCustomerSetting(botCode, config_value) {
        return $http.put(`/live-support/role-config/${botCode}/agent-allow-block-sender/`, {
            config_value: config_value
        })
    },
    updateEnableAutoMad(bot_code, status) {
        return $http.put(`/live-support/auto-mad-config/${bot_code}/update-enable-auto-mad/`, {
            status
        })
    },
    updateAutoMadConfigs(bot_code, auto_mad_configs) {
        return $http.put(`/live-support/auto-mad-config/${bot_code}/update-auto-mad-configs/`, auto_mad_configs)
    },
    setSLAConfig_EnableSLAMonitor(botCode, enable, config) {
        return $http.post(`/live-support/agent-sla/${botCode}/set`, {
            enable: enable,
            config: config
        })
    },
    getSLAConfigs(botCode){
        return $http.get(`/live-support/agent-sla/${botCode}/get`)
    },

    getConfigAlertFailedMessage(botCode) {
        return $http.get(`/live-support/${botCode}/alert-fail-message-emails`)
    },
    updateConfigAlertFailedMessage(botCode, alert_email_failed_message) {
        return $http.post(`/live-support/${botCode}/alert-fail-message-emails`, {
            emails: alert_email_failed_message
        })
    }
};

export default BotService
